<div
  class="donutwrap"
  [style.width.px]="size"
  [style.height.px]="size"
  [attr.data-value]="value"
  [attr.data-severity]="getComputedSeverity()"
>
  <svg [style.width.px]="size" [style.height.px]="size" viewBox="0 0 110 110">
    <circle
      class="meter"
      cx="55"
      cy="55"
      r="42"
      [attr.stroke]="getComputedRestColor()"
    ></circle>
    <circle
      class="value"
      cx="55"
      cy="55"
      r="42"
      [attr.stroke]="getComputedStrokeColor()"
    ></circle>
  </svg>
  <div [style.color]="getComputedStrokeColor()" [style.font-size.px]="size * 0.19" class="center-num"></div>
</div>

